import React from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material'
import { useDeleteWebhookMutation } from 'src/services/integration-service'
import toast from 'react-hot-toast'
import CloseIcon from '@mui/icons-material/Close'

const DeleteWebhookDialog = ({
  openDeleteModal,
  setOpenDeleteModal,
  setIntegration,
  webhookIdToDelete,
  setWebhookIdToDelete,
  webhookIdToDeleteName
}) => {
  const [deleteWebhook] = useDeleteWebhookMutation()

  const handleConfirmDelete = async (id) => {
    setIntegration(true)
    setOpenDeleteModal(false)
    const toastId = toast?.loading('Deleting webhook...', { duration: Infinity })
    try {
      const { message } = await deleteWebhook(webhookIdToDelete).unwrap()
      toast.success(message, { id: toastId, duration: 2000 })
    } catch (error) {
      toast.error('Failed to delete webhook', { id: toastId, duration: 2000 })
    }
    setIntegration(false)
  }

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false)
    setWebhookIdToDelete(null)
  }

  return (
    <>
      <Dialog
        open={openDeleteModal}
        onClose={handleCloseDeleteModal}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          '& .MuiDialog-paper': {
            width: { xs: '343px', md: '536px' },
            height: { xs: '290px', md: '218px' },
            border: '1px solid #E4E4E5',
            borderRadius: '8px',
            p: '8px 16px 16px 16px'
          }
        }}
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: { md: 'center' }, width: '100%', p: 0 }}>
          <Typography sx={{
            fontSize: { xs: '14px', md: '14px' },
            fontWeight: 700,
            lineHeight: '20px'
          }}
          >
            Are you sure you want to delete this webhook?
          </Typography>
          <IconButton
            onClick={handleCloseDeleteModal}
            aria-label='close'
          >
            <CloseIcon sx={{ fontSize: '20px', color: 'black' }} />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{
          width: '100%',
          p: 0,
          mt: '10px'
        }}
        >

          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
          }}
          >
            <Typography sx={{
              fontSize: { xs: '12px', md: '14px' },
              fontWeight: 500,
              lineHeight: '20px'
            }}
            >
              You are about to permanently delete the connection with the webhook <Typography component='span' sx={{ fontSize: { xs: '12px', md: '14px' }, fontWeight: 700 }}>{webhookIdToDeleteName}.</Typography>
            </Typography>
            <Typography sx={{
              fontSize: { xs: '12px', md: '14px' },
              fontWeight: 500,
              lineHeight: '20px',
              mt: '10px'
            }}
            >
              Data from Success.ai will no longer be sent to the target link.
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions sx={{ width: '100%', p: 0 }}>
          <Box sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            gap: { xs: '8px', md: '0px' },
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%'
          }}
          >
            <Button
              sx={{
                height: { xs: '34px', md: '42px' },
                width: { xs: '100%', md: '140px' },
                bgcolor: '#FF4545',
                fontSize: { xs: '12px', md: '14px' },
                fontWeight: 600,
                color: 'white',
                borderRadius: '8px',
                '&:hover': { bgcolor: '#FF4545' }
              }}
              onClick={handleConfirmDelete}
            >
              Delete webhook
            </Button>
            <Button
              sx={{
                height: { xs: '34px', md: '42px' },
                width: { xs: '100%', md: '76px' },
                border: '1px solid #E4E4E5',
                borderRadius: '8px',
                fontSize: { xs: '12px', md: '14px' }
              }}
              onClick={handleCloseDeleteModal}
            >
              Cancel
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default DeleteWebhookDialog
